import classNames from 'classnames'

import {CROSSFARMING_DOCUMENTATION_HREF_V2} from '../utils'

import styles from './DocumentationHintV2.pcss'

interface Props {
	className?: string
}

export function DocumentationHintV2({ className }: Props) {
	return (
		<div className={classNames(styles.container, className)}>
			<div className={styles.content}>
				<div className={styles.text}>
					<span className={styles.subtitle}>About</span>
					<br />
					Symbiosis cross-chain farming tracks the addition of
					liquidity to the Symbiosis pools and rewards each liquidity
					provider with SIS tokens.
				</div>

				<div className={styles.text}>
					Rewards are accrued once a week and are added to the
					liquidity providers' personal reward balances.
					<br />
					Some of the rewards become available to receive immediately;
					the other part is kept aside and can be claimed in full once
					the vesting period is over.
				</div>
			</div>
			<a
				className={styles.link}
				href={CROSSFARMING_DOCUMENTATION_HREF_V2}
				rel="noopener noreferrer"
				target="_blank"
			>
				<span className={styles.brace}>{'{'}</span> for more info read
				documentation <span className={styles.brace}>{'}'}</span>
			</a>
		</div>
	)
}
